import { render, staticRenderFns } from "./PreloadModelPreview.vue?vue&type=template&id=6980a586&scoped=true"
import script from "./PreloadModelPreview.vue?vue&type=script&lang=ts"
export * from "./PreloadModelPreview.vue?vue&type=script&lang=ts"
import style0 from "./PreloadModelPreview.vue?vue&type=style&index=0&id=6980a586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6980a586",
  null
  
)

export default component.exports